import React from 'react'

import appConfig from '../../appConfig'

const ProductListStructuredData = ({
  title = '',
  canonicalUrl = '',
  products = [],
  totalProductCount = 0,
  itemListElement,
  isIndexedPage
}) => {
  if (!isIndexedPage) return null

  let itemListElementStructuredData = []

  if (itemListElement) {
    const parsedStructuredData = JSON.parse(itemListElement || '[]')

    if (parsedStructuredData?.length === 0) {
      return null
    }

    itemListElementStructuredData = parsedStructuredData
  } else if (products?.length > 0) {
    itemListElementStructuredData = products?.map((product, index) => {
      if (!product?.priceArea?.priceInfo?.bottomPrice?.value) {
        return {}
      }

      return ({
        '@type': 'ListItem',
        'position': index + 1,
        'item': {
          '@type': 'Product',
          'name': product?.name,
          'image': product.images?.[0]?.linkFormat?.replace('{size}', '300-443'),
          'offers': {
            '@type': 'Offer',
            'price': product?.priceArea?.priceInfo?.bottomPrice?.value,
            'priceCurrency': 'TRY',
            'url': product?.productUrl?.includes('adservice') ? product?.productUrl : appConfig.baseUrl + product?.productUrl
          }
        }
      })
    })

    itemListElementStructuredData = itemListElementStructuredData?.filter(
      element => Object.keys(element)?.length > 0
    ) || []

    if (itemListElementStructuredData?.length === 0) {
      return null
    }
  } else {
    return null
  }

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    'name': title,
    'url': canonicalUrl,
    'numberOfItems': totalProductCount,
    'itemListElement': itemListElementStructuredData
  }

  let scriptTag = `<script type="application/ld+json">${JSON.stringify(structuredData)}</script>`;
  return (
    <div dangerouslySetInnerHTML={{__html: scriptTag}} />
  )
}

export default ProductListStructuredData
